import { render } from "./editar_disciplina_professor.vue?vue&type=template&id=e30e4336"
import script from "./editar_disciplina_professor.vue?vue&type=script&lang=js"
export * from "./editar_disciplina_professor.vue?vue&type=script&lang=js"

import "./editar_disciplina_professor.vue?vue&type=style&index=0&id=e30e4336&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__